import React from 'react';
import { FaArrowLeft, FaComments, FaEnvelope, FaPhone } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useCloudflareAuth } from '../../../contexts/CloudflareAuthContext';

const Support: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser, loading } = useCloudflareAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  if (!currentUser) {
    navigate('/login');
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 text-slate-300 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate('/dashboard')}
            className="p-2 hover:bg-slate-700 rounded-full transition-colors"
          >
            <FaArrowLeft className="text-slate-400" />
          </button>
          <h1 className="text-2xl font-bold text-emerald-400">Support</h1>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-slate-800/50 rounded-xl p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-emerald-500/20 rounded-full flex items-center justify-center">
            <FaComments className="w-10 h-10 text-emerald-400" />
          </div>

          <h2 className="text-2xl font-bold text-white mb-4">
            Support Chat Coming Soon
          </h2>

          <p className="text-slate-400 mb-8 max-w-md mx-auto">
            We're working on bringing you a seamless support experience.
            In the meantime, please contact us through the following channels:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-lg mx-auto">
            <a
              href="mailto:support@ccroindia.com"
              className="flex items-center gap-3 p-4 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors"
            >
              <FaEnvelope className="text-emerald-400" />
              <div className="text-left">
                <p className="text-sm text-slate-400">Email</p>
                <p className="text-white">support@ccroindia.com</p>
              </div>
            </a>
            
            <a
              href="tel:+917409832549"
              className="flex items-center gap-3 p-4 bg-slate-700/50 rounded-lg hover:bg-slate-700 transition-colors"
            >
              <FaPhone className="text-emerald-400" />
              <div className="text-left">
                <p className="text-sm text-slate-400">Phone</p>
                <p className="text-white">+91 7409832549</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
